<template>
	<div>
		<div class="main" style="margin-top: 0px;">
			<div class="part_title">
				{{region3_name}}
			</div>
			<div class="part_summary">
				{{region3_summary}}
			</div>
		</div>
		<div class="main" style="margin-top: 20px;">
			<el-row :gutter="20">
				<el-col :span="6" v-for="(item, index) in list_fangan" :key="index">
					<div class="fangan_box" @click="toUrl(item.url)" style="padding: 0px;">
						<div class="fangan_box_icon">
							<el-image :src="$common.adimgUrl + item.icon" style="width: 300px; height: 260px;"></el-image>
						</div>
					</div>
				</el-col>
			</el-row>
		</div>
		<!-- <div class="main" style="margin-top: 20px;">
			<el-row :gutter="20">
				<el-col :span="6" v-for="(item, index) in list_fangan" :key="index">
					<div class="fangan_box" @click="toUrl(item.url)">
						<div class="fangan_box_icon">
							<el-image :src="$common.adimgUrl + item.icon" style="height: 57px;" fit="contain"></el-image>
						</div>
						<div class="fangan_box_title">
							{{item.title}}
						</div>
						<div class="fangan_box_summary">
							{{item.summary}}
						</div>
					</div>
				</el-col>
			</el-row>
		</div> -->
		
		<div class="main" style="margin-top: 0px;">
			<div class="part_title">
				{{region4_name}}
			</div>
			<div class="part_summary">
				{{region4_summary}}
			</div>
		</div>
		<div class="main" style="margin-top: 20px;">
			<el-row>
				<el-col :span="12">
					<div class="fuwu_box" @click="toUrl(list_fuwu[0].url)">
						<div class="fuwu_box_icon">
							<el-image :src="list_fuwu[0].icon" style="height: 50px;" fit="contain"></el-image>
						</div>
						<div class="fuwu_box_title">
							{{list_fuwu[0].title}}
						</div>
						<div class="fuwu_box_summary">
							{{list_fuwu[0].summary}}
						</div>
					</div>
				</el-col>
				<el-col :span="12">
					<div class="fuwu_box" @click="toUrl(list_fuwu[1].url)" style="border-left: 1px solid #dedede;">
						<div class="fuwu_box_icon">
							<el-image :src="list_fuwu[1].icon" style="height: 50px;" fit="contain"></el-image>
						</div>
						<div class="fuwu_box_title">
							{{list_fuwu[1].title}}
						</div>
						<div class="fuwu_box_summary">
							{{list_fuwu[1].summary}}
						</div>
					</div>
				</el-col>
				<el-col :span="12">
					<div class="fuwu_box" @click="toUrl(list_fuwu[2].url)" style="border-bottom: 0px;">
						<div class="fuwu_box_icon">
							<el-image :src="list_fuwu[2].icon" style="height: 50px;" fit="contain"></el-image>
						</div>
						<div class="fuwu_box_title">
							{{list_fuwu[2].title}}
						</div>
						<div class="fuwu_box_summary">
							{{list_fuwu[2].summary}}
						</div>
					</div>
				</el-col>
				<el-col :span="12">
					<div class="fuwu_box" @click="toUrl(list_fuwu[3].url)" style="border-left: 1px solid #dedede; border-bottom: 0px;">
						<div class="fuwu_box_icon">
							<el-image :src="list_fuwu[3].icon" style="height: 50px;" fit="contain"></el-image>
						</div>
						<div class="fuwu_box_title">
							{{list_fuwu[3].title}}
						</div>
						<div class="fuwu_box_summary">
							{{list_fuwu[3].summary}}
						</div>
					</div>
				</el-col>
			</el-row>
		</div>
		
	</div>
</template>

<script>
	export default {
		props: ['region3_name', 'region3_summary', 'region4_name', 'region4_summary'],
		data() {
			return {
				list_fangan: [],
				list_fuwu: [
					{'title': '', 'summary': '', 'icon': ''}, 
					{'title': '', 'summary': '', 'icon': ''}, 
					{'title': '', 'summary': '', 'icon': ''}, 
					{'title': '', 'summary': '', 'icon': ''},
				], // 加上默认值，不加js会报错
				
			}
		},
		
		created() {
			
		},
		
		mounted() {
			this.loadFangan()
			this.loadFuwu()
		},
		
		methods: {
			// 加载解决方案4个推荐
			loadFangan () {
				this.$axios.get(this.$common.apiUrl + 'pub_web_config/detail/10011').then((res) => {
					this.list_fangan = eval('(' + res.data.data.configJson + ')')
				})
			},
			
			// 加载4个服务项
			loadFuwu () {
				this.$axios.get(this.$common.apiUrl + 'pub_web_config/detail/10012').then((res) => {
					this.list_fuwu = eval('(' + res.data.data.configJson + ')')
					this.list_fuwu.forEach((item, index) => {
						item.icon = this.$common.adimgUrl + item.icon
					})
				})
			},
			
			// web配置数据链接跳转
			toUrl(url) {
				// console.log(url)
				if (url.indexOf('http') > -1) {
					location.href = url
				} else {
					this.$router.push({path: url})
				}
			},
			
			
			
			
		}
	}
</script>

<style>
</style>